
import { defineComponent } from "vue";
import { themeName } from "@/core/helpers/documentation";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import Info from "@/components/sections/Info.vue";

export default defineComponent({
  name: "theme-color",
  components: {
    CodeHighlighter,
    Info
  },
  setup() {
    return {
      themeName
    };
  }
});
